<ng-container [formGroup]="form">
    <fieldset>

    <!--<div style="display: flex; flex-direction: row; justify-content: flex-start; gap: 16px;">-->
      <!-- Target -->
      <mat-form-field appearance="outline">
          <mat-label>{{ targetFieldLabel }}</mat-label>
          <mat-select formControlName="target">
              <mat-option *ngFor="let field of availableFields" [value]="field.id">
                  {{ field.name }}
              </mat-option>
          </mat-select>
      </mat-form-field>
      <!-- /Target -->

      <!-- Operator -->
      <mat-form-field appearance="outline">
          <mat-label>{{ operatorFieldLabel }}</mat-label>
          <mat-select formControlName="operator">
              <mat-option *ngFor="let operator of targetScopedOperators" [value]="operator.id">
                  {{ operator.name }}
              </mat-option>
          </mat-select>
      </mat-form-field>
      <!-- /Operator -->

      <!-- Value -->
      <mat-form-field *ngIf="targetIsBooleanType"
                      appearance="outline">
          <mat-label>{{ valueFieldLabel }}</mat-label>
          <mat-select formControlName="value">
              <mat-option [value]="true" i18n>Yes</mat-option>
              <mat-option [value]="false" i18n>No</mat-option>
          </mat-select>
      </mat-form-field>
      <mat-form-field *ngIf="!targetIsBooleanType && !targetHasDiscreteValues"
                      appearance="outline">
          <mat-label>{{ valueFieldLabel }}</mat-label>
          <input matInput formControlName="value" placeholder="valueFieldLabel">
      </mat-form-field>
      <mat-form-field *ngIf="!targetIsBooleanType && targetHasDiscreteValues"
                      appearance="outline">
          <mat-label>{{ valueFieldLabel }}</mat-label>
          <mat-select *ngIf="targetHasDiscreteValues" formControlName="value" multiple>
              <mat-option *ngFor="let value of targetDiscreteValues" [value]="value.id" [title]="value.name">
                  {{ value.name }}
              </mat-option>
          </mat-select>
      </mat-form-field>
      <!-- /Value -->
    <!--</div>-->

    </fieldset>
</ng-container>
